import { css } from '@emotion/css';
import authApi from 'apis/authApi';
import game3rdApi from 'apis/game3rdApi';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import LoadingIcon from 'components/loading/LoadingIcon';
import TagLabel from 'components/tag-label/TagLabel';
import globalStyle, { rotateAnimation } from 'constants/global.style';
import { colors } from 'constants/theme';
import { cacheUserInfo } from 'features/authSlice';
import HandlerError from 'helper/HandlerError';
import { Game3rdMenuItem } from 'models/commonModel';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FaArrowRight } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import { removeSeperateNumber } from 'utils/function';

interface Balance3rdGame {
    balance: string;
    msg: string;
}
interface Props {
    gameData: Game3rdMenuItem;
    onClose: () => void;
}
const listAmountQuick = [
    {
        value: 200000,
        label: '200K',
    },
    {
        value: 500000,
        label: '500K',
    },
    {
        value: 1000000,
        label: '1TR',
    },
    {
        value: 5000000,
        label: '5TR',
    },
    {
        value: 10000000,
        label: '10TR',
    },
    {
        value: 20000000,
        label: '20TR',
    },
    {
        value: 50000000,
        label: '50TR',
    },
    {
        value: 100000000,
        label: '100TR',
    },
    {
        value: 300000000,
        label: '300TR',
    },
];
function FastTransferGame(props: Props) {
    const { gameData, onClose } = props;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { userInfo, isLogged } = useAppSelector((state: RootState) => state.auth);
    const [amountGameTo, setAmountGameTo] = useState('');
    const [balance3rd, setBalance3rd] = useState<Balance3rdGame>({} as Balance3rdGame);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        checkMainBalance();
        checkBalance3rdGame();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameData]);

    const checkMainBalance = async (cb?: () => void) => {
        try {
            const { data } = await authApi.getUserInfo();
            HandlerError(
                data,
                () => {
                    dispatch(cacheUserInfo(data));
                    if (cb) cb();
                }, "getUserInfo");
        } catch (error) {
            console.log(error);
        }
    };

    const checkBalance3rdGame = async (cb?: () => void) => {
        let payload: any = {};
        if (gameData.providercode === "IBC2") {
            payload = { action: gameData.action, platform: 1 };
        } else if (gameData.providercode === "DG") {
            payload = { action: gameData.action, gameId: 'DG' };
        } else if (gameData.providercode === "PRAG") {
            payload = { action: gameData.action, gameId: 'PRAG' };
        } else if (gameData.providercode === "EVOLUTION") {
            payload = { action: gameData.action, gameId: 'EVOLUTION' };
        } else if (gameData.providercode === "JILI") {
            payload = { action: gameData.action, gameId: 'JILI' };
        } else if (gameData.providercode === "PGSOFT") {
            payload = { action: gameData.action, gameId: 'PGSOFT' };
        } else if (gameData.providercode === "PT") {
            payload = { action: gameData.action, gameId: 'PT' };
        } else { payload = { action: gameData.action } }
        try {
            const { data }: any = await game3rdApi.checkBalance(payload);
            if (data.cmdUserBalan) {
                setBalance3rd((item: any) => ({
                    ...item,
                    balance: data.cmdUserBalan.betAmount,
                    msg: data.message
                }))
            } else {
                setBalance3rd(data);
            }
            if (cb) cb();
        } catch (error) {
            console.log(error);
        }
    };

    const reloadBalance = (e: any, isMainBalance?: boolean) => {
        const elTarget = e.target as HTMLElement;
        const buttonEl = elTarget.closest('button');

        if (buttonEl) {
            buttonEl.classList.add('rotating');
        }
        if (isMainBalance) {
            checkMainBalance(() => {
                if (buttonEl) {
                    buttonEl.classList.remove('rotating');
                }
            });
        } else {
            checkBalance3rdGame(() => {
                if (buttonEl) {
                    buttonEl.classList.remove('rotating');
                }
            });
        }
    };

    const selectAllIn = () => {
        if (Number(userInfo.balance) < 500000000) {
            // lấy phần nguyên chia hết cho 1000
            const balane = Number(userInfo.balance) - (Number(userInfo.balance) % 1000);
            console.log(balane);
            setAmountGameTo(String(balane));
        } else {
            setAmountGameTo(String(500000000));
        }
    };

    const submitPlayGame = async () => {
        if (!isLogged) {
            toast.error('Vui lòng đăng nhập');
            return;
        }
        if (balance3rd.msg) {
            toast.error(balance3rd.msg);
            return;
        }

        setLoading(true);
        const payload = {
            sname: gameData.valSname,
            svalue: gameData.valSvalue
        }
        try {
            const { data } = await game3rdApi.sysGame3rdLoginBean(payload);
            if (!data.msg) {
                Login3RDGame(gameData.port, gameData.providercode);
                onClose();
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const getPayload = (portApi: string, gameData: any) => {
        const { providercode, gametype } = gameData;

        const payloadMap: Record<string, any> = {
            IBC2: { action: portApi, platform: 1 },
            DG: { action: portApi, gameId: 'DG' },
            EVOLUTION: { action: portApi, gameId: 'EVOLUTION' },
            'PRAG_SL': { action: portApi, gameId: 'PRAG' },
            'PRAG_LC': { action: portApi, gameId: 'PRAG_CASINO' },
            'DS_FH': { action: portApi, gametype: 110 },
            'JILI_SL': { action: portApi, sname: 'Slots', svalue: 'jili_slot' },
            'JILI_FH': { action: portApi, sname: 'Slots', svalue: 'jili_slot' },
            'PGSOFT_SL': { action: portApi, sname: 'Slots', svalue: 'pgs_slot' },
            'PT_SL': { action: portApi, sname: 'Slots', svalue: 'pt_slot' },
            'PT_LC': { action: portApi, sname: 'Slots', svalue: 'pt_slot' },
        };

        return payloadMap[`${providercode}_${gametype}`] ||
            payloadMap[providercode] ||
            { action: portApi };
    };

    const openGameWindow = (id: string, data: any, gameData: any, navigate: any) => {
        const { gametype } = gameData;

        const openWindow = (url: string) => window.open(url, '_blank');

        const handlers: Record<string, () => void> = {
            CMD: () => {
                if (data.cmdLaunchGame) {
                    const { webRoot, userName, token } = data.cmdLaunchGame;
                    const link = `${webRoot}/auth.aspx?lang=vi-VN&user=${userName}&token=${token}&currency=VD&templatename=green&view=v1`;
                    openWindow(link);
                }
            },
            IBC2: () => {
                if (data.error_code === 11000 || data.ibcSessionToken === '') {
                    toast.error('Đang bảo trì, vui lòng quay lại sau!');
                } else {
                    openWindow(data.ibcSessionToken);
                }
            },
            BTI: () => openWindow(data.webUrl),
            AG: () => openWindow(data.linkGameForward),
            WM: () => openWindow(data.wmSessionToken),
            SA: () => openWindow(data.url),
            SG: () => openWindow(data.gameLaunchUrl),
            PRAG_LC: () => openWindow(new URL(data.listUrl[0]).toString()),
            PRAG_SL: () => navigate(`/slots?idgame=PRAG`),
            HABA: () => navigate(`/slots?idgame=HABA`),
            DS_SL: () => navigate(`/slots?idgame=DS`),
            JILI_SL: () => navigate(`/slots?idgame=JILI`),
            JILI_FH: () => navigate(`/slots?idgame=JILI&cat=5`),
            PGSOFT_SL: () => navigate(`/slots?idgame=PGSOFT`),
            PT_SL: () => navigate(`/slots?idgame=PT`),
            PT_LC: () => navigate(`/slots?idgame=PT&cat=live`),
            DG: () => openWindow(data.listUrl[0]),
            EVOLUTION: () => openWindow(data.listUrl[0]),
            V8: () => openWindow(data.gameLaunchUrl),
            DS_FH: () => openWindow(data.forwardGame),
        };

        const key = `${id}_${gametype}`;
        const handler = handlers[key] || handlers[id];

        if (handler) handler();
    };

    const Login3RDGame = async (portApi: string, id: string) => {
        const payload = getPayload(portApi, gameData);

        const { data } = await game3rdApi.Login3RD(payload);

        HandlerError(
            data,
            () => {
                if (data.msg || data.message) {
                    toast.error(data.msg || data.message);
                    return;
                }
                openGameWindow(id, data, gameData, navigate);
            },
            portApi
        );
    };

    const submitTransfer = async () => {
        const amountTransfer = Number(removeSeperateNumber(amountGameTo));

        if (Number(userInfo.balance) < amountTransfer) {
            toast.error('Tài khoản chính không đủ');
            return;
        }
        if (amountTransfer % 1000 > 0) {
            toast.error('Số tiền giao dịch phải chia hết cho 1,000');
            return;
        }
        if (amountTransfer < 1e3) {
            toast.error('Số tiền giao dịch nhỏ nhất là 1,000');
            return;
        }
        if (amountTransfer > 5e8) {
            toast.error('Số tiền giao dịch nhiều nhất là 500,000,000');
            return;
        }

        setLoading(true);
        let payloadFund: object = {};
        const payload = { action: gameData.actiond, direction: 0, amount: amountTransfer / gameData.money };
        const payloadIbc = { action: gameData.actiond, direction: 5, amount: amountTransfer / 1000, platform: 1 };
        const payloadwm = { action: gameData.actiond, direction: 10, amount: amountTransfer / 1000 };
        const payloadsg = { action: gameData.actiond, direction: 0, amount: amountTransfer };
        const payloadsa = { action: gameData.actiond, direction: 0, amount: amountTransfer / 1000 };
        const payloaddg = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'DG' };
        const payloadprag = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'PRAG' };
        const payloadEvl = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'EVOLUTION' };
        const payloadJili = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'JILI' };
        const payloadPgs = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'PGSOFT' };
        const payloadPt = { action: gameData.actiond, direction: 1, amount: amountTransfer, gameId: 'PT' };
        if (gameData?.providercode === "SG") {
            payloadFund = payloadsg
        } else if (gameData?.providercode === "WM") {
            payloadFund = payloadwm;
        } else if (gameData?.providercode === "IBC2") {
            payloadFund = payloadIbc;
        } else if (gameData?.providercode === "SA" || gameData?.providercode === "HABA" || gameData?.providercode === "AG") {
            payloadFund = payloadsa
        } else if (gameData?.providercode === "DG") {
            payloadFund = payloaddg
        } else if (gameData?.providercode === "PRAG") {
            payloadFund = payloadprag
        } else if (gameData?.providercode === "EVOLUTION") {
            payloadFund = payloadEvl
        } else if (gameData?.providercode === "JILI") {
            payloadFund = payloadJili
        } else if (gameData?.providercode === "PGSOFT") {
            payloadFund = payloadPgs
        } else if (gameData?.providercode === "PT") {
            payloadFund = payloadPt
        } else {
            payloadFund = payload
        }

        try {
            const { data } = await game3rdApi.submitTransfer(payloadFund);
            if (!data.msg && !data.message) {
                toast.success('Giao dịch thành công');
                setAmountGameTo('');
                checkMainBalance();

                //reload balance game 3 chuyển quỹ
                checkBalance3rdGame();
            } else {
                toast.error(data.msg || data.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className={styles.wrapTransfer}>
                <div className={styles.heading}>
                    <h6 className={styles.title}>Chuyển Quỹ</h6>
                    <button type="button" className={styles.btnClose} onClick={onClose}>
                        <IoMdClose size={30} color={colors.white} />
                    </button>
                </div>
                <div className={styles.wrapBalance}>
                    <div className={styles.titleFundTranfer}>
                        <label>Tài Khoản Chính</label>
                        <FaArrowRight size={18} />
                        <label>{gameData?.name}</label>
                    </div>
                    <div className={styles.amountList}>
                        {listAmountQuick.map((item) => (
                            <div className={styles.amountItem} key={item.value}>
                                <p className={styles.amountItemInner} onClick={() => setAmountGameTo(String(item.value))}>
                                    {item.label}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className={styles.groupBalance}>
                        <p className={`${globalStyle.inputCommon} ${styles.amountValue}`}>{userInfo.balance ? new Intl.NumberFormat().format(Number(userInfo.balance)) : 0}</p>
                        <button type="button" className={styles.btnRefresh} onClick={(e) => reloadBalance(e, true)}>
                            <img src={require('assets/images/icons/refresh.png')} alt="" />
                        </button>
                    </div>
                    <div className={styles.groupBalance}>
                        <p className={`${globalStyle.inputCommon} ${styles.amountValue}`}>
                            {balance3rd.msg ? <span className={styles.msgError}>{balance3rd.msg}</span> : new Intl.NumberFormat().format(Number(balance3rd.balance || 0) * gameData?.money)}
                        </p>
                        <button type="button" className={styles.btnRefresh} onClick={(e) => reloadBalance(e)}>
                            <img src={require('assets/images/icons/refresh.png')} alt="" />
                        </button>
                    </div>
                </div>
                <div className={`${styles.groupBalance} ${styles.groupInput}`}>
                    <label htmlFor="">Số Tiền (VNĐ)</label>
                    <div className={styles.groupAmount}>
                        <div style={{ flex: 1 }}>
                            <NumericFormat
                                className={globalStyle.inputCommon}
                                thousandSeparator=","
                                placeholder="Nhập số tiền..."
                                value={amountGameTo}
                                onChange={(e) => setAmountGameTo(e.target.value)}
                            />
                            <TagLabel label="Ít nhất 1,000 VNĐ - Nhiều nhất 500,000,000 VNĐ" />
                        </div>
                        <button type="button" className={styles.btnMax} onClick={selectAllIn}>
                            Tối đa
                        </button>
                    </div>
                </div>
                <div className={styles.action}>
                    <button type="button" className={globalStyle.btnSecondary} onClick={submitPlayGame}>
                        Vào Trò Chơi
                    </button>
                    <button type="button" className={globalStyle.btnPrimary} disabled={!amountGameTo} onClick={submitTransfer}>
                        Xác Nhận
                    </button>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    wrapTransfer: css`
        background: ${colors.lottery};
        border-radius: 8px;
        border: 1px solid ${colors.borderPrimary};
        padding: 3px 16px 16px;
        color: ${colors.white};
        margin: 0 auto;
    `,
    amountList: css`
        display: flex;
        flex-wrap: wrap;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 5px;
        margin-bottom: 20px;
        justify-content: center;
    `,
    amountItem: css`
        padding: 4px;
        flex: 0 0 33%;
        max-width: 33%;
    `,
    amountItemInner: css`
        padding: 8px 0;
        border-radius: 8px;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, .4);
        cursor: pointer;
        text-align: center;
        background: rgba(0, 0, 0, .4);
        color: var(--white-color);
        font-weight: 700;
        &:active, &:hover {
            background: linear-gradient(0deg, #002287 0%, rgba(2, 126, 251, 1) 100%);
        }
    `,
    titleFundTranfer: css`
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 5px;
        padding: 5px;
        margin-bottom: 10px;
    `,
    title: css`
        flex: 1;
        padding-left: 30px;
        text-align: center;
        font-size: 20px;
    `,
    btnClose: css`
        width: 40px;
        height: 40px;
        cursor: pointer;
    `,
    heading: css`
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    `,
    amountValue: css`
        border-color: transparent;
        background: #011e98;
        color: #ffffff;
    `,
    wrapBalance: css`
        position: relative;
    `,
    iconArrow: css`
        position: absolute;
        left: 30px;
        top: 33px;
    `,
    groupBalance: css`
        margin-bottom: 10px;
        display: flex;
        /* align-items: center; */
        position: relative;
        flex-direction: column;
        label {
            display: block;
            margin-bottom: 4px;
            padding-left: 2px;
            /* flex: 0 0 120px; */
        }
    `,
    btnRefresh: css`
        position: absolute;
        top: calc(50% - 13px);

        right: 2px;
        display: flex;
        padding: 4px;
        cursor: pointer;
        &.rotating {
            pointer-events: none;
            animation: ${rotateAnimation} 0.8s linear infinite;
        }
        img {
            width: 18px;
            opacity: 0.8;
        }
    `,
    msgError: css`
        font-size: 14px;
        color: ${colors.red};
        white-space: nowrap;
        width: 100%;
        padding-right: 22px;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    action: css`
        display: flex;
        gap: 12px;
    `,
    groupInput: css`
        align-items: flex-start;
        label {
            padding-top: 8px;
        }
    `,
    groupAmount: css`
        flex: 1;
        display: flex;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
    `,
    btnMax: css`
        border: 1px solid ${colors.blue};
        height: 36px;
        padding: 0 8px;
        color: ${colors.white};
        font-size: 14px;
        border-radius: 6px;
        &:active {
            background: ${colors.primary};
        }
    `,
};

export default FastTransferGame;
